import { DocumentoDetalle } from '../models/DocumentoDetalle';
import { Cliente } from './cliente';

export class Documento {

	public DOCUMENT_ID: number;
	public CREATION_DATE: Date;
	public CREATED_BY: number;
	public PREVIOUS_DOCUMENT_ID: number;
	public DOCUMENT_NUMBER: string;
	public CUSTOMER_SUPPLIER_CONTACT_ID: number;
	public DOCUMENT_TYPE_ID: number;
	public PLACE_OF_DELIVERY: string;
	public DOCUMENT_DATE: any;
	public DELIVERY_COMMITMENT_DATE: any;
	public SUBTOTAL: number;
	public IVA: number;
	public PERCENTAGE_DISCOUNT: number;
	public AMOUNT_DISCOUNT: number;
	public TOTAL: number;
	public COMMENTS: string;
	public CUSTOMER_SUPPLIER_ID: number;
	public cliente: Cliente;
	public clienteSearch?: any;
	public COMPANY_ID: number;
	public PERSON_ID: number;
	public DEBT: number;
	public PREVIOUS_DEBT: number;

	// Campos Fase 2
	public AMOUNT_UTILITY: number;
	public PERCENTAGE_UTILITY: number;
	public PURCHASE_TOTAL: number;
	public METHOD_PAYMENT_ID: number;
	public ORGANIZATION_ID: number;

	// Campos utilizados en la pantalla de agregar venta
	public Productos: DocumentoDetalle[];
	public Cargos: DocumentoDetalle[];
	public UTILITY_INFO: string;

	// Campo de dirección de entrega
	public CUSTOMER_ADDRESS_ID: number;

	public MEANING: number;

	public ESTATUS: string;

	constructor() {
		this.DOCUMENT_ID = null;
		this.CREATION_DATE = null;
		this.CREATED_BY = null;
		this.PREVIOUS_DOCUMENT_ID = null;
		this.DOCUMENT_NUMBER = null;
		this.CUSTOMER_SUPPLIER_CONTACT_ID = null;
		this.DOCUMENT_TYPE_ID = null;
		this.PLACE_OF_DELIVERY = null;
		this.DOCUMENT_DATE = new Date();
		this.DELIVERY_COMMITMENT_DATE = null;
		this.SUBTOTAL = 0;
		this.IVA = 0;
		this.PERCENTAGE_DISCOUNT = null;
		this.AMOUNT_DISCOUNT = null;
		this.TOTAL = 0;
		this.COMMENTS = null;
		this.CUSTOMER_SUPPLIER_ID = null;
		this.COMPANY_ID = null;
		this.PERSON_ID = null;

		this.AMOUNT_UTILITY = null;
		this.PERCENTAGE_UTILITY = null;
		this.PURCHASE_TOTAL = null;
		this.METHOD_PAYMENT_ID = null;

		this.Productos = [];
		this.Cargos = [];
		this.UTILITY_INFO = null;
		this.CUSTOMER_ADDRESS_ID = null;
	}

}


// WEBPACK FOOTER //
// ./src/app/models/documento.ts